@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/business-cards-2x3/glass-house-business-card-stack-content/glass-house-price/glass-house-price.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.pricing-container {
  display: flex;
  gap: 0.1875rem;
}
.pricing-headers,
.prices-container {
  display: flex;
  flex-direction: column;
}
.prices-container {
  padding-right: 0.5625rem;
  gap: 0.25rem;
}
.pricing-headers {
  justify-content: space-between;
  padding-bottom: 0.25rem;
  gap: 0.25rem;
}
.pricing-header {
  font-family: inter, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 0.5625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: transparent;
  line-height: 0.625rem;
  padding-right: 0.125rem;
  height: 1.375rem;
}
::ng-deep .product-variant-price {
  font-family: inter, sans-serif;
  font-weight: 700;
  font-style: normal;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
  width: unset;
}
::ng-deep .product-variant-price .product-variant-current-price,
::ng-deep .product-variant-price .product-variant-previous-price {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
::ng-deep .product-variant-price .product-variant-previous-price {
  font-size: 0.5625rem;
  text-decoration: unset;
  text-align: left;
}
::ng-deep .product-variant-price .product-variant-previous-price .product-variant-price-decoration {
  font-size: 0.3125rem;
  line-height: 150%;
}
::ng-deep .product-variant-price .product-variant-current-price {
  font-size: 1.1875rem;
}
::ng-deep .product-variant-price .product-variant-price-decoration,
::ng-deep .product-variant-price .leading-text-current-price {
  font-size: 0.625rem;
  line-height: 150%;
}
.pre-tax {
  opacity: 0.38;
}
::ng-deep .force-italic-style * {
  font-family: inter, sans-serif;
  font-weight: 700;
  font-style: italic;
}
::ng-deep .force-bold-style * {
  font-family: inter, sans-serif;
  font-weight: 900;
  font-style: normal;
}
/*# sourceMappingURL=glass-house-price.component.css.map */
